export type Language = 'fi' | 'en' | 'sv';

export const translations: Record<Language, Record<string, string>> = {
    'fi': {
        'export': 'Vie Exceliin',
        'sections': 'Osiot',
        'sections_and_content': 'Osiot ja sisällöt',
        'start': 'Aloita',
        'answer': 'Vastaa',
        'translate_from': 'Käännä kielestä',
        'play_again': 'Pelaa uudelleen',
        'remove_selection': 'Poista valinta',
        'continue': 'Jatka',
        'choose_answer': 'Valitse vastaus',
        'close': 'Sulje',
        'fill_all_fields': 'Täytä kaikki kentät',
        'select_multiple_info': 'Valitse yksi tai useampi vaihtoehto',
        'select_single_info': 'Valitse yksi vaihtoehto',
        'order_info': 'Järjestä vaihtoehdot haluamaasi järjestykseen',
        'connect_info': 'Yhdistä vaihtoehdot vetämällä ne toistensa päälle',
        'error_loading_game': 'Virhe ladattaessa peliä',
        'points_scored': 'Pisteet',
        'game_average': 'Pelin keskiarvo',
        'all_players_average': 'Kaikkien pelaajien keskiarvo',
        'pages': 'Sivut',
        'filter': 'Suodata',
        'search_games': 'Hae pelejä',
        'status': 'Tila',
        'status_published': 'Julkaistu',
        'status_draft': 'Luonnos',
        'status_archived': 'Arkistoitu',
        'status_not_in_use': 'Ei käytössä',
        'name': 'Nimi',
        'games_played': 'Pelattuja pelejä',
        'modified': 'Muokattu',
        'all': 'Kaikki',
        'clear_filters': 'Tyhjennä suodattimet',
        'edit': 'Muokkaa',
        'common_info': 'Yleistiedot',
        'average_duration': 'Keskimääräinen kesto',
        'average': 'Keskiarvo',
        'min': 'min',
        'sec': 'sek',
        'average_points': 'Keskimääräiset pisteet',
        'max_points': 'Maksimipisteet',
        'game_image': 'Pelin kuva',
        'general': 'Yleistiedot',
        'slug': 'Osoite',
        'description': 'Kuvaus',
        'excerpt': 'Nostoteksti',
        'outro_text': 'Vastaamisen jälkeinen viesti',
        'outro_text_info': 'Tämä teksti näytetään käyttäjälle, kun hän on vastannut kysymykseen.',
        'multiple': 'Useita vastauksia',
        'content_type': 'Sisältötyyppi',
        'content': 'Sisältö',
        'title': 'Otsikko',
        'select_options': 'Vaihtoehdot',
        'add_option': 'Lisää vaihtoehto',
        'points': 'Pisteet',
        'order_options': 'Järjestä vaihtoehdot',
        'connect_options': 'Yhdistä vaihtoehdot',
        'save': 'Tallenna',
        'select_content_type': 'Valitse sisällön tyyppi',
        'all_types': 'Kaikki tyypit',
        'type_slide': 'Slide',
        'type_select': 'Valinta',
        'type_order': 'Järjestä',
        'type_connect': 'Yhdistä',
        'type_select_multiple': 'Monivalinta',
        'type_text': 'Tekstivastaus',
        'type_image': 'Kuva',
        'type_title': 'Väliotsikko',
        'new_question': 'Uusi kysymys',
        'new_content': 'Uusi sisältö',
        'theme': 'Teema',
        'search': 'Hae ...',
        'select': 'Valitse',
        'new_section': 'Uusi osio',
        'new_game': 'Uusi peli',
        'quit_game': 'Poistu',
        'submit': 'Lähetä',
        'cancel': 'Peruuta',
        'add_new': 'Lisää uusi',
        'section_updated': 'Osio päivitetty',
        'section_created': 'Osio luotu',
        'not_available': 'Ei saatavilla',
        'game_section_order_updated': 'Pelin osioiden järjestys päivitetty',
        'game_saved': 'Pelin tiedot tallennettu',
        'question_created': 'Kysymys luotu',
        'question_updated': 'Kysymys päivitetty',
        'add_language': 'Lisää kieli',
        'select_language': 'Valitse kieli',
        'edit_order': 'Muokkaa järjestystä',
        'language_versions': 'Kieliversiot',
        'version': 'Versio',
        'session': 'Pelisessio',
        'sessions': 'Pelisessiot',
        'latest_sessions': 'Viimeisimmät istunnot',
        'started': 'Aloitettu',
        'ended': 'Päättyi',
        'question_language': 'Kysymyksen kieli',
        'search_questions': 'Hae kysymyksiä',
        'show_all': 'Näytä kaikki',
        'played': 'Pelattu',
        'created': 'Luotu',
        'language': 'Kieli',
        'languages': 'Kielet',
        'type': 'Tyyppi',
        'duration': 'Kesto',
        'select_status': 'Valitse tila',
        'search_sessions': 'Hae sessioita',
        'games': 'Pelit',
        'game': 'Peli',
        'questions': 'Kysymykset',
        'questions_played': 'Pelattuja kysymyksiä',
        'users': 'Käyttäjät',
        'player_name': 'Pelaajan nimi',
        'duplicate': 'Kopioi peli',
        'game_duplicated': 'Peli kopioitu',
        'new_theme': 'Uusi teema',
        'add_theme': 'Lisää teema',
        'image': 'Kuva',
        'add_user': 'Lisää käyttäjä',
        'search_users': 'Hae käyttäjiä',
        'add_team': 'Lisää tiimi',
        'teams': 'Tiimit',
        'username': 'Käyttäjätunnus',
        'email': 'Sähköposti',
        'is_staff': 'Ylläpitäjä',
        'is_active': 'Käytössä',
        'new_user': 'Uusi käyttäjä',
        'edit_user': 'Käyttäjän muokkaus',
        'first_name': 'Etunimi',
        'last_name': 'Sukunimi',
        'company': 'Yritys',
        'password': 'Salasana',
        'repeat_password': 'Toista salasana',
        'new_team': 'Uusi tiimi',
        'team_name': 'Tiimin nimi',
        'allowed_emails': 'Sallitut sähköpostipäätteet',
        'section_contents': 'Osion sisällöt',
        'display_correct_answers': 'Näytä oikeat vastaukset',
        'select_theme': 'Valitse teema',
        'question_and_answer': 'Kysymys ja vastaus',
        'answered': 'Vastattiin',
        'of_answers': 'vastauksista',
        'slides': 'Slidet',
        'order': 'Järjestys',
        'average_order': 'Keskimääräinen järjestys',
        'game_name': 'Pelin nimi',
        'most_popular_games': 'Pelatuimmat pelit',
        'latest_events': 'Viimeisimmät tapahtumat',
        'description_of_event': 'Tapahtuman kuvaus',
        'when': 'Milloin',
        'ago': 'sitten',
        'weeks': 'viikkoa',
        'days': 'päivää',
        'hours': 'tuntia',
        'months': 'kuukautta',
        'week': 'viikko',
        'day': 'päivä',
        'hour': 'tunti',
        'month': 'kuukausi',
        'theme_and_image': 'Teema ja nostokuva',
        'start_screen': 'Aloitusruutu',
        'end_screen': 'Lopetusruutu',
        'end_screen_text': 'Lopetusruudun teksti',
        'end_screen_points': 'Lopputuloksen pisterajat',
        'edit_team': 'Muokkaa tiimiä',
        'avg_max': 'Keskiarvo / maksimi',
        'allowed_domains': 'Sallitut sähköpostipäätteet',
        'url_copied': 'URL kopioitu leikepöydälle!',
        'url_copy_failed': 'URL:n kopioiminen epäonnistui.',
        'passed': 'Läpäisty',
        'connected': 'Yhdistettiin',
        'selections': 'Valintakerrat',
        'times': 'kertaa',
        'video': 'Video',
        'vimeo': 'Vimeo',
        'game_created': 'Peli luotu',
        'min_points': 'Pelin läpäisyyn vaadittavat pisteet %',
        'dashboard': 'Hallintapaneeli',
        'themes': 'Teemat',
        'start_screen_text': 'Aloitusruudun teksti',
        'terms': 'Tietosuojaseloste',
        'end_form_thanks': 'Kiitosviesti lopetusruudun lomakkeen jälkeen',
        'point_range_text': 'Pisterajan teksti',
        'required_points': 'Tarvittavat pisteet',
        'forms': 'Lomakkeet',
        'fields': 'Kentät',
        'new_form': 'Uusi lomake',
        'edit_form': 'Muokkaa lomaketta',
        'add_field': 'Lisää kenttä',
        'name_field': 'Nimikenttä',
        'email_field': 'Sähköpostikenttä',
        'custom_field': 'Mukautettu kenttä',
        'field_label': 'Kentän nimi',
        'field_type': 'Tyyppi',
        'field_required': 'Pakollinen',
        'text': 'Teksti',
        'checkbox': 'Valintalaatikko',
        'text_element': 'Tekstirivi',
        'used_in_games': 'Käytössä peleissä',
        'date_joined': 'Liittynyt',
        'last_seen': 'Viimeksi nähty',
        'invitation_link': 'Kutsulinkki',
        'start_date': 'Aloituspvm.',
        'end_date': 'Lopetuspvm.',
        'games_played_total': 'Kaikki pelatut pelit',
        'compared_to_previous': 'Verrattuna edelliseen jaksoon',
        'new': 'Uusi',
        'new_plural': 'Uudet',
        'total': 'Yhteensä',
        'days_abbreviation': 'pv',
        'right_answers': 'Täysin oikeita vastauksia',
        'wrong_answers': 'Täysin vääriä vastauksia',
        'question_type': 'Kysymystyyppi',
        'team': 'Tiimi',
        'search_teams': 'Hae tiimejä',
        'enter_emails': 'Lisää sähköpostipäätteitä',
        'enter_emails_help': 'Syötä sähköpostipäätteitä ja paina Enter',
        'correct_positions': 'Oikeat sijainti',
        'incorrect_positions': 'Väärät sijainnit',
        'summary': 'Yhteenveto',
        'positions': 'Sijainnit',
        'position': 'Sijainti',
        'no_data': 'Ei dataa saatavilla',
        'correct_pairs': 'Oikeat parit',
        'correct_connections': 'Oikein yhdistetty',
        'incorrect_connections': 'Väärin yhdistetty',
        'section_settings': 'Osion asetukset',
        'game_sections_and_contents': 'Pelin osiot ja sisällöt',
        'game_settings': 'Pelin asetukset',
        'slide_positioning': 'Sliden asemointi',
        'or': 'tai',
        'slide_content': 'Sliden sisältö',
        'delete': 'Poista',
        'confirm_delete_session': 'Haluatko varmasti poistaa pelisession?',
        'confirm_delete_theme': 'Haluatko varmasti poistaa teeman?',
        'no': 'Ei',
        'yes': 'Kyllä',
        'connected_to': 'Yhdistetty',
        'connections': 'Yhdistelmät',
        'select_teams': 'Valitse tiimit',
        'no_teams_selected': 'Ei valittuja tiimejä',
        'is_superuser': 'Pääkäyttäjä',
        'loading': 'Ladataan...',
        'inactive': 'Ei käytössä',
        'used_in': 'Käytössä',
        'logout': 'Kirjaudu ulos',
        'back_to_site': 'Takaisin sivustolle',
        'add': 'Lisää',
        'allowed_teams': 'Rajattu tiimeille',
        'collections': 'Kokoelmat',
        'collection': 'Kokoelma',
        'new_collection': 'Uusi kokoelma',
        'lift_text': 'Nostoteksti',
        'lift_image': 'Nostokuva',
        'collection_games': 'Kokoelman pelit',
        'collection_visible': 'Nayta kokoelma etusivulla',
        'select_collections': 'Valitse kokoelmat',
        'no_collections_selected': 'Ei valittuja kokoelmia',
        'restrict_playing': 'Rajoita pelaaminen vain kirjautuneille',
        'only_login': 'Vain kirjautuneille',
        'game_min_points': 'Läpäisyyn vaadittavat pisteet',
        'language_settings': 'Kielikohtaiset asetukset',
        'start_screen_form': 'Aloitusruudun lomake',
        'start_screen_form_help': 'Valitse lomake, joka näytetään pelin aloitusruudulla.',
        'end_screen_form': 'Lopetusruudun lomake',
        'select_form': 'Valitse lomake',
        'theme_and_lift_settings': 'Teema- ja nostoasetukset',
        'show_lift': 'Näytä nosto sivustolla',
        'show_lift_help': 'Nosto pelistä näytetään sivustolla, jos peli on käytössä.',
        'date_range': 'Aikarajaus',
        'confirm_delete_question': 'Haluatko varmasti poistaa kysymyksen?',
        'confirm_delete_section': 'Haluatko varmasti poistaa osion ja kaikki sen sisällöt?',
        'confirm_delete_user': 'Haluatko varmasti poistaa käyttäjän?',
        'section': 'Osio',
        'question': 'Kysymys',
        'lift_image_help': 'Näytetään pelin aloitusruudulla sekä nostoissa<br>sallitut kuvamuodot png/jpg koko 500x500px',
        'theme_help': 'Valitse tai lisää peliin sopiva teema <br> Teemaa käytetään myös pelin osioissa jos niissä ei ole omaa teemaa',
        'team_help': 'Rajaa peli tiimeille, jotka voivat pelata peliä',
        'display_correct_help': 'Näytä oikeat vastaukset sekä pisteet pelaajille',
        'restrict_playing_help': 'Rajoita pelaaminen vain kirjautuneille käyttäjille',
        'upload_image': 'Lataa kuva',

        'end_title': 'Lopetusruudun otsikko',
        'is_active_help_text': 'Onko peli pelattavissa kieliversiolla',
        'publish_version': 'Julkaise versio',
        'publish_in': 'Ota peli käyttöön kielellä',
        'screens': 'Aloitus- ja lopetusruudun asetukset',
        'game_end_redirect': 'Pelin lopetuksen ohjausosoite',
        'event_details': 'Tapahtuman tiedot',
        'changes': 'Muutokset',
        'field': 'Kenttä',
        'old_value': 'Vanha arvo',
        'new_value': 'Uusi arvo',
        'delete_language_version': 'Poista kieliversio',
        'confirm_delete_game_language': 'Haluatko varmasti poistaa pelin kieliversion? <br> Jos poistat kaikki kieliversiot, peli arkistoidaan kokonaan.',
        'game_language_version': 'Pelin kieliversio',
        'not_found_title': 'Sivua ei löytynyt',
        'not_found_description': 'Hups, sivua ei löytynyt!',
        'version_override_help': 'Olet julkaisemassa pelistä uutta versiota. Muutokset näkyvät pelissä heti.',
        'type_open_text': 'Tekstivastaus',
        'draft_info': 'Huom! Pelin nykyinen versio on julkaistu, kaikki muutokset näkyvät peleissä heti.',
        'theme_info': 'Huom! Teema on käytössä, kaikki muutokset näkyvät peleissä heti.',
        'confirm_delete_form': 'Haluatko varmasti poistaa lomakkeen?',
        'confirm_delete_team': 'Haluatko varmasti poistaa tiimin?',
        'confirm_delete_collection': 'Haluatko varmasti poistaa kokoelman?',
        'user': 'Käyttäjä',
        'is_active_info': 'Huom! Jos peli on julkaistu, kaikki muutokset näkyvät heti pelissä.',
        'open_options': 'Tekstivastaus',
        'textarea': 'Tekstialue',
        'create': 'Luo',
        'confirm_draft_create': 'Huom! Luo uusi versio vain, jos haluat muokata kysymysten pisteitä tai vastausvaihtoehtoja tai lisätä sivuja tai osioita.',
        'export_to_excel': 'Vie Exceliin',
        'upload_video': 'Lataa video',
        'published_info': 'Huom! Julkaistussa versiossa et voi muokata pelin pisteitä tai lisätä sisältöjä.<br> Jos haluat tehdä muutoksia, luo uusi versio.',
        'no_options': 'Ei hakutuloksia',
        'theme_help_section': 'Valitse tai lisää osioon sopiva teema <br> Tämä yliajaa pelin teeman.',
        'confirm_delete': 'Vahvista poisto',
        'playable': 'Pelattavissa',
        'create_new_version': 'Luo uusi versio',
        'continue_editing': 'Jatka version muokkaamista',
        'end_screen_points_help': 'Voit luoda pisterajoihin perustuvia viestejä, jotka näytetään pelaajalle pelin päätyttyä.',
        'excerpt_help': 'Nostotekstiä käytetään sivuston nostoissa, jos nosto näytetään sivustolla.',
        'theme_image_help': 'Kuvaa käytetään taustakuvana<br> Kuvakoko 1920x1080 <br> Sallitut kuvamuodot png/jpg',
        'enter_emails_help_text': 'Tiimiin liittyminen sallitaan vain valituilla sähköpostipäätteillä, voit lisätä useita sähköpostipäätteitä.',
        'copy_team_url': 'Kopioi kutsu-URL leikepöydälle',
        'copy_url': 'Kopioi URL',
        'slide_image_help': 'Sallitut kuvamuodot png/jpg',
        'slide_video_help': 'Sallitut videotyypit mp4',
        'just_now': 'juuri nyt',
        'change': 'Vaihda',
        'state': 'Tila',
        'preview': 'Esikatselu',
        'admin': 'Hallinta',
        'autoplay': 'Automaattinen toisto',
        'loop_video': 'Toista video jatkuvasti',
        'only_title': 'Näytä vain otsikko taustan päällä',
        'invitation_links': 'Kutsulinkit',
        'edit_link': 'Muokkaa kutsulinkkiä',
        'new_link': 'Uusi kutsulinkki',
        'max_usages': 'Käyttömäärä',
        'use_end': 'Vanhenee',
        'use_amount': 'Käyttömäärä',
        'is_anonymous': 'Anonyymi',
        'select_team': 'Valitse tiimi',
        'select_game': 'Valitse peli',
        'created_by': 'Luonut',
        'description_emails': 'Sähköpostiosoitteet / Kuvaus',
        'ago_abbr': '',
        'background_image': 'Taustakuva',
        'logo': 'Logo',
        'theme_logo_help': 'Kuvaa käytetään teeman logona<br> Käytä vain vaakakuvia <br> Sallitut kuvamuodot png/jpg/svg',
        'save_and_continue': 'Tallenna ja jatka muokkaamista',
        'shuffle_options': 'Näytä vastausvaihtoehdot arvotussa järjestyksessä',
        'select_basic': 'Vaihtoehto',
        'select_open': 'Avoin vastaus',
        'display_end_screen_points': 'Näytä pisteet lopetusruudulla',
        'display_end_screen_points_help': 'Näytä pelaajalle pelin pisteet lopetusruudulla',
        'change_remove': 'Vaihda / Poista',
        'image_help': 'Sallitut kuvamuodot png/jpg',

        'section_background_help': 'Kuvaa käytetään osion taustakuvana<br> Kuvakoko 1920x1080 <br> Sallitut kuvamuodot png/jpg',
        'layout': 'Asettelu',
        'default': 'Oletus',
        'tag_layout': 'Tagit',
        'twin_columns': 'Kaksipalstainen',
        'add_content': 'Lisää sisältöä',
        'element': 'Elementti',
        'settings': 'Asetukset',
        'confirm_delete_element': 'Haluatko varmasti poistaa elementin?',
        'confirm_delete_row': 'Haluatko varmasti poistaa rivin ja kaikki sen sisältämät sisällöt?',
        'edit_element': 'Muokkaa elementtiä',
        'add_element': 'Lisää elementti',
        'notifications': 'Ilmoitukset',
        'upload_pdf': 'Tuo sisältö (PDF)',
        'pdf_file': 'PDF-tiedosto',
        'pdf_file_help': 'PDF-tiedoston sivuista luodaan osion sisällöt.',
        'description_info': 'Lisäkuvaus, joka näytetään kysymyksen yhteydessä.',
        'element_image_title_help': 'Tämä teksti näkyy vain hallinnassa.',
        'pdf_processing_pending': 'Odotetaan PDF-tiedoston käsittelyä',
        'pdf_processing_in_progress': 'Käsitellään PDF-tiedostoa',
        'pdf_processing_completed': 'PDF-tiedoston käsittely valmis',
        'pdf_processing_failed': 'PDF-tiedoston käsittely epäonnistui',
        'pdf_page': 'sivu',
        'statistics': 'Tilastot',
        'export_pdf': 'Lataa PDF',
        'time_limit': 'Aikaraja (s)',
        'time_limit_help': 'Sallittu aika vastata kysymykseen sekunteina 5-3600 s',
        'number_scale': 'Numeroasteikko',
        'min_value': 'Minimi',
        'max_value': 'Maksimi',
        'nps_scale': 'NPS-asteikko',
        'nps_low': 'Erittäin epätodennäköisesti',
        'nps_high': 'Erittäin todennäköisesti',
        'rating': 'Arvosana',
        'label': 'Teksti',
        'percentage': 'Prosenttia',
        'nps_rating': 'NPS-indeksi',
        'promoters': 'Suosittelijat (9-10)',
        'passives': 'Passiiviset (7-8)',
        'detractors': 'Kriittiset (0-6)',
        'allow_answer_change': 'Salli vastauksen vaihto',
        'allow_answer_change_help': 'Salli pelaajalle mahdollisuus vaihtaa vastaustaan',
        'allow_skip': 'Salli kysymyksen ohitus',
        'skip_question': 'Jätä vastaamatta',
        'og_image': 'OG-kuva',
        'og_image_help': 'Sallitut kuvamuodot png/jpg, suositeltu kuvakoko 1200x630 px.',
    },
    'en': {
        'export': 'Export',
        'text_element': 'Text',
        'sections': 'Sections',
        'start': 'Start',
        'answer': 'Answer',
        'play_again': 'Play again',
        'remove_selection': 'Remove selection',
        'continue': 'Continue',
        'choose_answer': 'Choose answer',
        'close': 'Close',
        'fill_all_fields': 'Fill all fields',
        'select_multiple_info': 'Select one or more options',
        'select_single_info': 'Select one option',
        'order_info': 'Order the options correctly',
        'connect_info': 'Connect the correct options',
        'error_loading_game': 'Error loading game',
        'points_scored': 'Points',
        'game_average': 'Game average',
        'all_players_average': 'All players average',
        'confirm_exit': 'Are you sure you want to exit? The game cannot be shared if you exit during the game.',
        'page': 'Page',
        'pages': 'Pages',
        'filter': 'Filter',
        'search_games': 'Search games',
        'add_game': 'Add game',
        'game_language': 'Game language',
        'game_languages': 'Game languages',
        'all_languages': 'All languages',
        'game_status': 'Game status',
        'status': 'Status',
        'status_published': 'Published',
        'status_draft': 'Draft',
        'status_archived': 'Archived',
        'status_not_in_use': 'Not in use',
        'own_modified': 'Own modified',
        'name': 'Name',
        'games_played': 'Games played',
        'modified': 'Modified',
        'actions': 'Actions',
        'all': 'All',
        'clear_filters': 'Clear filters',
        'back_to_list': 'Back to list',
        'edit': 'Edit',
        'common_info': 'Common Info',
        'average_duration': 'Average duration',
        'average': 'Average',
        'min': 'min',
        'sec': 'sec',
        'average_points': 'Average points',
        'max_points': 'Max points',
        'game_image': 'Game image',
        'terms': 'Privacy policy',
        'end_form_thanks': 'Thank you message (after form)',
        'general': 'General',
        'slug': 'Slug',
        'description': 'Description',
        'excerpt': 'Excerpt',
        'outro_text': 'Outro text',
        'multiple': 'Multiple',
        'content_type': 'Content type',
        'title': 'Title',
        'select_options': 'Options',
        'add_option': 'Add option',
        'points': 'Points',
        'order_options': 'Order options',
        'connect_options': 'Connect options',
        'save': 'Save',
        'select_question_type': 'Select question type',
        'all_types': 'All types',
        'type_slide': 'Slide',
        'type_select': 'Select',
        'type_order': 'Order',
        'type_connect': 'Connect',
        'type_image': 'Image',
        'new_question': 'New question',
        'new_content': 'New content',
        'new_game': 'New game',
        'theme': 'Theme',
        'search': 'Search...',
        'select': 'Select',
        'new_section': 'New section',
        'quit_game': 'Quit game',
        'submit': 'Submit',
        'cancel': 'Cancel',
        'add_new': 'Add new',
        'section_updated': 'Section updated',
        'section_created': 'Section created',
        'not_available': 'Not available',
        'game_section_order_updated': 'Game section order updated',
        'game_saved': 'Game details saved',
        'question_created': 'Question created',
        'question_updated': 'Question updated',
        'add_language': 'Add language',
        'select_language': 'Select language',
        'edit_order': 'Edit order',
        'language_versions': 'Language versions',
        'latest_sessions': 'Latest sessions',
        'session': 'Game session',
        'sessions': 'Game sessions',
        'started': 'Started',
        'ended': 'Ended',
        'question_language': 'Question language',
        'search_questions': 'Search questions',
        'show_all': 'Show all',
        'played': 'Played',
        'created': 'Created',
        'language': 'Language',
        'languages': 'Languages',
        'type': 'Type',
        'duration': 'Duration',
        'select_status': 'Select status',
        'search_sessions': 'Search sessions',
        'games': 'Games',
        'questions': 'Questions',
        'questions_played': 'Questions played',
        'users': 'Users',
        'player_name': 'Player name',
        'duplicate': 'Duplicate as new',
        'game_duplicated': 'Game duplicated',
        'new_theme': 'New theme',
        'add_theme': 'Add theme',
        'image': 'Image',
        'video': 'Video',
        'vimeo': 'Vimeo',
        'add_user': 'Add user',
        'search_users': 'Search users',
        'add_team': 'Add team',
        'teams': 'Teams',
        'collections': 'Collections',
        'collection': 'Collection',
        'new_collection': 'New collection',
        'lift_text': 'Lift text',
        'lift_image': 'Lift image',
        'collection_games': 'Collection games',
        'collection_visible': 'Show collection on main view',
        'select_collections': 'Select collections',
        'no_collections_selected': 'No collections selected',
        'confirm_delete_collection': 'Are you sure you want to delete the collection?',
        'username': 'Username',
        'email': 'Email',
        'is_staff': 'Is staff',
        'is_active': 'Is active',
        'new_user': 'New user',
        'edit_user': 'Edit user',
        'first_name': 'First name',
        'last_name': 'Last name',
        'company': 'Company',
        'password': 'Password',
        'repeat_password': 'Repeat password',
        'new_team': 'New team',
        'team_name': 'Team name',
        'allowed_emails': 'Allowed emails',
        'section_contents': 'Section contents',
        'display_correct_answers': 'Display correct answers',
        'select_theme': 'Select theme',
        'question_and_answer': 'Question and answer',
        'answered': 'Answered',
        'slides': 'Slides',
        'in_game': 'in game',
        'order': 'Order',
        'average_order': 'Average order',
        'game_name': 'Game name',
        'most_popular_games': 'Most popular games',
        'og_image': 'OG image',
        'og_image_help': 'Allowed image formats png/jpg, recommended size 1200x630 px.',
    },
    'sv': {
        'export': 'Exportera till Excel',
        'sections': 'Sektioner',
        'sections_and_content': 'Sektioner och innehåll',
        'start': 'Starta',
        'answer': 'Svara',
        'translate_from': 'Översätt från',
        'play_again': 'Spela igen',
        'remove_selection': 'Ta bort val',
        'continue': 'Fortsätt',
        'choose_answer': 'Välj svar',
        'close': 'Stäng',
        'fill_all_fields': 'Fyll i alla fält',
        'select_multiple_info': 'Välj ett eller flera alternativ',
        'select_single_info': 'Välj ett alternativ',
        'order_info': 'Ordna alternativen i önskad ordning',
        'connect_info': 'Koppla alternativen genom att dra dem på varandra',
        'error_loading_game': 'Fel vid laddning av spel',
        'points_scored': 'Poäng',
        'game_average': 'Spelmedeltal',
        'all_players_average': 'Medeltal för alla spelare',
        'pages': 'Sidor',
        'filter': 'Filtrera',
        'search_games': 'Sök spel',
        'status': 'Status',
        'status_published': 'Publicerad',
        'status_draft': 'Utkast',
        'status_archived': 'Arkiverad',
        'status_not_in_use': 'Inte i bruk',
        'name': 'Namn',
        'games_played': 'Spelade spel',
        'modified': 'Redigerad',
        'all': 'Alla',
        'clear_filters': 'Rensa filter',
        'edit': 'Redigera',
        'common_info': 'Allmän information',
        'average_duration': 'Genomsnittlig längd',
        'average': 'Medeltal',
        'min': 'min',
        'sec': 'sek',
        'average_points': 'Genomsnittliga poäng',
        'max_points': 'Maximal poäng',
        'game_image': 'Spelbild',
        'general': 'Allmän information',
        'slug': 'Adress',
        'description': 'Beskrivning',
        'excerpt': 'Lyfttext',
        'outro_text': 'Meddelande efter svar',
        'outro_text_info': 'Denna text visas för användaren när hen har svarat på frågan.',
        'multiple': 'Flera svar',
        'content_type': 'Innehållstyp',
        'content': 'Innehåll',
        'title': 'Rubrik',
        'select_options': 'Alternativ',
        'add_option': 'Lägg till alternativ',
        'points': 'Poäng',
        'order_options': 'Ordna alternativ',
        'connect_options': 'Koppla alternativ',
        'save': 'Spara',
        'select_content_type': 'Välj innehållstyp',
        'all_types': 'Alla typer',
        'type_slide': 'Slide',
        'type_select': 'Val',
        'type_order': 'Ordna',
        'type_connect': 'Koppla',
        'type_select_multiple': 'Flerval',
        'type_text': 'Textsvar',
        'type_image': 'Bild',
        'type_title': 'Mellanrubrik',
        'new_question': 'Ny fråga',
        'new_content': 'Nytt innehåll',
        'theme': 'Tema',
        'search': 'Sök...',
        'select': 'Välj',
        'new_section': 'Ny sektion',
        'new_game': 'Nytt spel',
        'quit_game': 'Lämna',
        'submit': 'Skicka',
        'cancel': 'Avbryt',
        'add_new': 'Lägg till ny',
        'section_updated': 'Sektion uppdaterad',
        'section_created': 'Sektion skapad',
        'not_available': 'Ej tillgänglig',
        'game_section_order_updated': 'Spelets sektionsordning uppdaterad',
        'game_saved': 'Spelinformation sparad',
        'question_created': 'Fråga skapad',
        'question_updated': 'Fråga uppdaterad',
        'add_language': 'Lägg till språk',
        'select_language': 'Välj språk',
        'edit_order': 'Redigera ordning',
        'language_versions': 'Språkversioner',
        'version': 'Version',
        'session': 'Spelsession',
        'sessions': 'Spelsessioner',
        'latest_sessions': 'Senaste sessioner',
        'started': 'Startad',
        'ended': 'Avslutad',
        'question_language': 'Frågans språk',
        'search_questions': 'Sök frågor',
        'show_all': 'Visa alla',
        'played': 'Spelade',
        'created': 'Skapad',
        'language': 'Språk',
        'languages': 'Språk',
        'type': 'Typ',
        'duration': 'Längd',
        'select_status': 'Välj status',
        'search_sessions': 'Sök sessioner',
        'games': 'Spel',
        'game': 'Spel',
        'questions': 'Frågor',
        'questions_played': 'Spelade frågor',
        'users': 'Användare',
        'player_name': 'Spelarens namn',
        'duplicate': 'Kopiera spel',
        'game_duplicated': 'Spelet kopierat',
        'new_theme': 'Nytt tema',
        'add_theme': 'Lägg till tema',
        'image': 'Bild',
        'add_user': 'Lägg till användare',
        'search_users': 'Sök användare',
        'add_team': 'Lägg till team',
        'teams': 'Team',
        'username': 'Användarnamn',
        'email': 'E-post',
        'is_staff': 'Administratör',
        'is_active': 'I bruk',
        'new_user': 'Ny användare',
        'edit_user': 'Redigera användare',
        'first_name': 'Förnamn',
        'last_name': 'Efternamn',
        'company': 'Foretag',
        'password': 'Lösenord',
        'repeat_password': 'Upprepa lösenord',
        'new_team': 'Nytt team',
        'team_name': 'Teamnamn',
        'allowed_emails': 'Tillåtna e-postdomäner',
        'section_contents': 'Sektionens innehåll',
        'display_correct_answers': 'Visa rätta svar',
        'select_theme': 'Välj tema',
        'question_and_answer': 'Fråga och svar',
        'answered': 'Svarade',
        'of_answers': 'av svaren',
        'slides': 'Slider',
        'order': 'Ordning',
        'average_order': 'Genomsnittlig ordning',
        'game_name': 'Spelets namn',
        'most_popular_games': 'Mest spelade spel',
        'latest_events': 'Senaste händelser',
        'description_of_event': 'Händelsebeskrivning',
        'when': 'När',
        'ago': 'sedan',
        'weeks': 'veckor',
        'days': 'dagar',
        'hours': 'timmar',
        'months': 'månader',
        'week': 'vecka',
        'day': 'dag',
        'hour': 'timme',
        'month': 'månad',
        'theme_and_image': 'Tema och lyftbild',
        'start_screen': 'Startskärm',
        'end_screen': 'Slutskärm',
        'end_screen_text': 'Slutskärmstext',
        'end_screen_points': 'Poänggränser för slutresultat',
        'edit_team': 'Redigera team',
        'avg_max': 'Medeltal / maximum',
        'allowed_domains': 'Tillåtna e-postdomäner',
        'url_copied': 'URL kopierad till urklipp!',
        'url_copy_failed': 'Misslyckades med att kopiera URL.',
        'passed': 'Godkänd',
        'connected': 'Kopplade',
        'selections': 'Antal val',
        'times': 'gånger',
        'video': 'Video',
        'vimeo': 'Vimeo',
        'game_created': 'Spel skapat',
        'min_points': 'Poäng som krävs för att klara spelet %',
        'dashboard': 'Kontrollpanel',
        'themes': 'Teman',
        'start_screen_text': 'Startskärmstext',
        'terms': 'Integritetspolicy',
        'end_form_thanks': 'Tackmeddelande efter slutskärmens formulär',
        'point_range_text': 'Text för poänggräns',
        'required_points': 'Poäng som krävs',
        'forms': 'Formulär',
        'fields': 'Fält',
        'new_form': 'Nytt formulär',
        'edit_form': 'Redigera formulär',
        'add_field': 'Lägg till fält',
        'name_field': 'Namnfält',
        'email_field': 'E-postfält',
        'custom_field': 'Anpassat fält',
        'field_label': 'Fältnamn',
        'field_type': 'Typ',
        'field_required': 'Obligatorisk',
        'text': 'Text',
        'checkbox': 'Kryssruta',
        'text_element': 'Textrad',
        'used_in_games': 'Används i spel',
        'date_joined': 'Gick med',
        'last_seen': 'Senast sedd',
        'invitation_link': 'Inbjudningslänk',
        'start_date': 'Startdatum',
        'end_date': 'Slutdatum',
        'games_played_total': 'Alla spelade spel',
        'compared_to_previous': 'Jämfört med föregående period',
        'new': 'Ny',
        'new_plural': 'Nya',
        'total': 'Totalt',
        'days_abbreviation': 'd',
        'right_answers': 'Helt rätta svar',
        'wrong_answers': 'Helt felaktiga svar',
        'question_type': 'Frågetyp',
        'team': 'Team',
        'search_teams': 'Sök team',
        'enter_emails': 'Lägg till e-postdomäner',
        'enter_emails_help': 'Ange e-postdomäner och tryck på Enter',
        'correct_positions': 'Rätt positioner',
        'incorrect_positions': 'Fel positioner',
        'summary': 'Sammanfattning',
        'positions': 'Positioner',
        'position': 'Position',
        'no_data': 'Ingen data tillgänglig',
        'correct_pairs': 'Rätta par',
        'correct_connections': 'Rätt kopplade',
        'incorrect_connections': 'Fel kopplade',
        'section_settings': 'Sektionsinställningar',
        'game_sections_and_contents': 'Spelets sektioner och innehåll',
        'game_settings': 'Spelinställningar',
        'slide_positioning': 'Slidepositionering',
        'or': 'eller',
        'slide_content': 'Slideinnehåll',
        'delete': 'Ta bort',
        'confirm_delete_session': 'Är du säker på att du vill ta bort spelsessionen?',
        'confirm_delete_theme': 'Är du säker på att du vill ta bort temat?',
        'no': 'Nej',
        'yes': 'Ja',
        'connected_to': 'Kopplad',
        'connections': 'Kombinationer',
        'select_teams': 'Välj team',
        'no_teams_selected': 'Inga team valda',
        'is_superuser': 'Superanvändare',
        'loading': 'Laddar...',
        'inactive': 'Inaktiv',
        'used_in': 'Används i',
        'logout': 'Logga ut',
        'back_to_site': 'Tillbaka till webbplatsen',
        'add': 'Lägg till',
        'allowed_teams': 'Begränsad till team',
        'collections': 'Samlingar',
        'collection': 'Samling',
        'new_collection': 'Ny samling',
        'lift_text': 'Lyfttext',
        'lift_image': 'Lyftbild',
        'collection_games': 'Samlingens spel',
        'collection_visible': 'Visa samling pa startsidan',
        'select_collections': 'Välj samlingar',
        'no_collections_selected': 'Inga samlingar valda',
        'restrict_playing': 'Begränsa spelande till endast inloggade',
        'only_login': 'Endast för inloggade',
        'game_min_points': 'Poäng som krävs för att klara',
        'language_settings': 'Språkspecifika inställningar',
        'start_screen_form': 'Startskärmsformulär',
        'start_screen_form_help': 'Välj formuläret som visas på spelets startskärm.',
        'end_screen_form': 'Slutskärmsformulär',
        'select_form': 'Välj formulär',
        'theme_and_lift_settings': 'Tema- och lyftinställningar',
        'show_lift': 'Visa lyftet på webbplatsen',
        'show_lift_help': 'Lyftet från spelet visas på webbplatsen om spelet är aktivt.',
        'date_range': 'Tidsbegränsning',
        'confirm_delete_question': 'Är du säker på att du vill ta bort frågan?',
        'confirm_delete_section': 'Är du säker på att du vill ta bort sektionen och allt dess innehåll?',
        'confirm_delete_user': 'Är du säker på att du vill ta bort användaren?',
        'section': 'Sektion',
        'question': 'Fråga',
        'lift_image_help': 'Visas på spelets startskärm och i lyft<br>tillåtna bildformat png/jpg storlek 500x500px',
        'theme_help': 'Välj eller lägg till ett passande tema för spelet <br> Temat används också i spelets sektioner om de inte har ett eget tema',
        'team_help': 'Begränsa spelet till team som kan spela spelet',
        'display_correct_help': 'Visa rätta svar och poäng för spelarna',
        'restrict_playing_help': 'Begränsa spelande till endast inloggade användare',
        'upload_image': 'Ladda upp bild',
        'end_title': 'Slutskärmsrubrik',
        'is_active_help_text': 'Är spelet spelbart på språkversionen',
        'publish_version': 'Publicera version',
        'publish_in': 'Aktivera spelet på språket',
        'screens': 'Inställningar för start- och slutskärm',
        'game_end_redirect': 'Omdirigerings-URL efter avslutat spel',
        'event_details': 'Händelseinformation',
        'changes': 'Ändringar',
        'field': 'Fält',
        'old_value': 'Gammalt värde',
        'new_value': 'Nytt värde',
        'delete_language_version': 'Ta bort språkversion',
        'confirm_delete_game_language': 'Är du säker på att du vill ta bort spelets språkversion? <br> Om du tar bort alla språkversioner arkiveras spelet helt.',
        'game_language_version': 'Spelets språkversion',
        'not_found_title': 'Sidan hittades inte',
        'not_found_description': 'Hoppsan, sidan hittades inte!',
        'version_override_help': 'Du håller på att publicera en ny version av spelet. Ändringarna syns i spelet omedelbart.',
        'type_open_text': 'Textsvar',
        'draft_info': 'Obs! Den aktuella versionen av spelet är publicerad, alla ändringar syns i spelen omedelbart.',
        'theme_info': 'Obs! Temat används, alla ändringar syns i spelen omedelbart.',
        'confirm_delete_form': 'Är du säker på att du vill ta bort formuläret?',
        'confirm_delete_team': 'Är du säker på att du vill ta bort teamet?',
        'confirm_delete_collection': 'Är du säker på att du vill ta bort samlingen?',
        'user': 'Användare',
        'is_active_info': 'Obs! Om spelet är publicerat syns alla ändringar i spelet omedelbart.',
        'open_options': 'Textsvar',
        'textarea': 'Textarea',
        'create': 'Skapa',
        'confirm_draft_create': 'Obs! Skapa en ny version endast om du vill redigera frågepoäng eller svaralternativ eller lägga till sidor eller sektioner.',
        'export_to_excel': 'Exportera till Excel',
        'upload_video': 'Ladda upp video',
        'published_info': 'Obs! I den publicerade versionen kan du inte redigera spelpoäng eller lägga till innehåll.<br> Om du vill göra ändringar, skapa en ny version.',
        'no_options': 'Inga sökresultat',
        'theme_help_section': 'Välj eller lägg till ett passande tema för sektionen <br> Detta åsidosätter spelets tema.',
        'confirm_delete': 'Bekräfta borttagning',
        'playable': 'Spelbar',
        'create_new_version': 'Skapa ny version',
        'continue_editing': 'Fortsätt redigera versionen',
        'end_screen_points_help': 'Du kan skapa meddelanden baserade på poänggränser som visas för spelaren när spelet är slut.',
        'excerpt_help': 'Lyfttexten används i webbplatsens lyft om lyftet visas på webbplatsen.',
        'theme_image_help': 'Bilden används som bakgrundsbild<br> Bildstorlek 1920x1080 <br> Tillåtna bildformat png/jpg',
        'enter_emails_help_text': 'Gå med i team är endast tillåtet med valda e-postdomäner, du kan lägga till flera e-postdomäner.',
        'copy_team_url': 'Kopiera inbjudnings-URL till urklipp',
        'copy_url': 'Kopiera URL',
        'slide_image_help': 'Tillåtna bildformat png/jpg',
        'slide_video_help': 'Tillåtna videotyper mp4',
        'just_now': 'just nu',
        'change': 'Byt',
        'state': 'Status',
        'preview': 'Förhandsvisning',
        'admin': 'Administration',
        'autoplay': 'Automatisk uppspelning',
        'loop_video': 'Spela upp videon kontinuerligt',
        'only_title': 'Visa endast rubrik ovanpå bakgrunden',
        'invitation_links': 'Inbjudningslänkar',
        'edit_link': 'Redigera inbjudningslänk',
        'new_link': 'Ny inbjudningslänk',
        'max_usages': 'Antal användningar',
        'use_end': 'Löper ut',
        'use_amount': 'Antal användningar',
        'is_anonymous': 'Anonym',
        'select_team': 'Välj team',
        'select_game': 'Välj spel',
        'created_by': 'Skapad av',
        'description_emails': 'E-postadresser / Beskrivning',
        'ago_abbr': '',
        'background_image': 'Bakgrundsbild',
        'logo': 'Logotyp',
        'theme_logo_help': 'Bilden används som temats logotyp<br> Använd endast horisontella bilder <br> Tillåtna bildformat png/jpg/svg',
        'save_and_continue': 'Spara och fortsätt redigera',
        'shuffle_options': 'Visa svaralternativ i slumpmässig ordning',
        'select_basic': 'Alternativ',
        'select_open': 'Öppet svar',
        'display_end_screen_points': 'Visa poäng på slutskärmen',
        'display_end_screen_points_help': 'Visa spelets poäng för spelaren på slutskärmen',
        'change_remove': 'Byt / Ta bort',
        'image_help': 'Tillåtna bildformat png/jpg',
        'section_background_help': 'Bilden används som sektionens bakgrundsbild<br> Bildstorlek 1920x1080 <br> Tillåtna bildformat png/jpg',
        'layout': 'Asettelju',
        'default': 'Standard',
        'tag_layout': 'Taggar',
        'twin_columns': 'Tvåspaltig',
        'add_content': 'Lägg till innehåll',
        'element': 'Element',
        'settings': 'Inställningar',
        'confirm_delete_element': 'Är du säker på att du vill ta bort elementet?',
        'confirm_delete_row': 'Är du säker på att du vill ta bort raden och allt dess innehåll?',
        'edit_element': 'Redigera element',
        'add_element': 'Lägg till element',
        'notifications': 'Meddelanden',
        'upload_pdf': 'Importera innehåll (PDF)',
        'pdf_file': 'PDF-fil',
        'pdf_file_help': 'Sektionens innehåll skapas från PDF-filens sidor.',
        'description_info': 'Tilläggsbeskrivning som visas i samband med frågan.',
        'element_image_title_help': 'Denna text visas endast i administrationen.',
        'pdf_processing_pending': 'Väntar på PDF-bearbetning',
        'pdf_processing_in_progress': 'Bearbetar PDF-filen',
        'pdf_processing_completed': 'PDF-bearbetning klar',
        'pdf_processing_failed': 'PDF-bearbetning misslyckades',
        'pdf_page': 'sida',
        'statistics': 'Statistik',
        'export_pdf': 'Ladda ner PDF',
        'time_limit': 'Tidsgräns (s)',
        'time_limit_help': 'Tillåten tid att svara på frågan i sekunder 5-3600 s',
        'number_scale': 'Nummerskala',
        'min_value': 'Minimum',
        'max_value': 'Maximum',
        'nps_scale': 'NPS-skala',
        'nps_low': 'Mycket osannolikt',
        'nps_high': 'Mycket sannolikt',
        'rating': 'Betyg',
        'label': 'Text',
        'percentage': 'Procent',
        'nps_rating': 'NPS-index',
        'promoters': 'Förespråkare (9-10)',
        'passives': 'Passiva (7-8)',
        'detractors': 'Kritiker (0-6)',
        'allow_answer_change': 'Tillåt byte av svar',
        'allow_answer_change_help': 'Tillåt spelaren att byta sitt svar',
        'allow_skip': 'Tillåt att hoppa över frågan',
        'skip_question': 'Lämna obesvarad',
        'og_image': 'OG-bild',
        'og_image_help': 'Tillåtna bildformat png/jpg, rekommenderad bildstorlek 1200x630 px.',
    }
};
